module.exports = __webpack_public_path__ + "img/frasagal02.d043352b.png";